"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useCataloguesLandingPageContext = exports.cataloguesLandingPageContext = exports.Provider = exports.CataloguesLandingPageProvider = void 0;
var _react = require("react");
var _api = require("../api");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore file @preserve -- No need to test passing of data to context.
const defaultCataloguesLandingPageContextValues = {
    data: null,
    loading: true
};
const cataloguesLandingPageContext = exports.cataloguesLandingPageContext = /*#__PURE__*/ (0, _react.createContext)(defaultCataloguesLandingPageContextValues);
const { Provider } = cataloguesLandingPageContext;
exports.Provider = Provider;
const CataloguesLandingPageProvider = (param)=>{
    let { children } = param;
    const value = (0, _api.useGetCatalogueLandingPageData)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Provider, {
        value: value,
        children: children
    });
};
exports.CataloguesLandingPageProvider = CataloguesLandingPageProvider;
const useCataloguesLandingPageContext = ()=>(0, _react.useContext)(cataloguesLandingPageContext);
exports.useCataloguesLandingPageContext = useCataloguesLandingPageContext;
